import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import groupBy from 'lodash.groupby'
import { Timetable } from '@/externals/gyym/user/timetables'
import { Area, AreaList } from './types'

dayjs.locale('ja')

const getTimeInt = (time: string) => parseInt(time.replace(':', ''), 10)

export const groupTimetablesByAvailableDateAndTimeSpan = (
  timetables: Timetable[],
  limit?: number
) => {
  const timetableByDate = groupBy(timetables, (timetable) =>
    dayjs(timetable.startAt).format('M/D(dd)')
  )
  const dates = Object.keys(timetableByDate)
  return (limit ? dates.slice(0, limit) : dates).reduce(
    (acc, date) => ({
      ...acc,
      [date]: groupBy(timetableByDate[date], ({ startAt }) => {
        const startAtTime = getTimeInt(dayjs(startAt).format('H:mm'))
        switch (true) {
          case getTimeInt('3:00') <= startAtTime &&
            startAtTime <= getTimeInt('10:59'):
            return '朝'
          case getTimeInt('11:00') <= startAtTime &&
            startAtTime <= getTimeInt('17:59'):
            return '昼'
          default:
            // 18:00 ~ 2:59
            return '夜'
        }
      }),
    }),
    {}
  )
}

export const areasToList = (areas: Area[]): AreaList => {
  return areas.reduce(
    (acc, area) => ({
      ...acc,
      [area.id]: area.name,
    }),
    {}
  )
}
